import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FinderButtonComponent } from './finder-button.component';
import { LinkIdDirectiveModule } from '@finder/shared/directives/link-id/link-id.module';
import { LocaleDirectiveModule } from '@finder/shared/directives/locale/locale.module';

@NgModule({
    imports: [
        CommonModule,
        LinkIdDirectiveModule,
        LocaleDirectiveModule,
    ],
    declarations: [
        FinderButtonComponent,
    ],
    providers: [],
    exports: [
        FinderButtonComponent,
    ]
})
export class FinderButtonModule {}
